import icProgramFesta from "@/assets/images/user/icProgramFesta.svg";
import programFestaCont1Img1 from "@/assets/images/user/programFestaCont1Img1.jpg";
import programFestaCont1Img2 from "@/assets/images/user/programFestaCont1Img2.jpg";
import programFestaCont2Img1 from "@/assets/images/user/programFestaCont2Img1.jpg";
import programFestaCont2Img2 from "@/assets/images/user/programFestaCont2Img2.jpg";
import programFestaCont3Img1 from "@/assets/images/user/programFestaCont3Img1.jpg";
import programFestaCont3Img2 from "@/assets/images/user/programFestaCont3Img2.jpg";
import programFestaCont4Img1 from "@/assets/images/user/programFestaCont4Img1.jpg";
import programFestaCont4Img2 from "@/assets/images/user/programFestaCont4Img2.jpg";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";

const txtBoxClass =
    "max-w-[72px] w-full text-[16px] py-[4px] text-[#000] font-['GongGothicMedium'] text-center leading-[25px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[10px]";

const programList = [
    {
        title: "인디크래프트",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9/19(금)~9/20(토), 13:00 ~ 19:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교테크원 B1, 1F, 판교역 역사
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            2025 인디크래프트&apos; 대한민국 대표 <br className="md:hidden" />
                            인디게임들을 만날 수 있는 절호의 기회! <br />
                            여름을 즐기는 최고의 방법, <br className="md:hidden" />
                            지금 바로 전시 공간에 어서오세요
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont1Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont1Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "일러스타 페스",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9/19(금)~9/20(토), 13:00 ~ 20:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 서측광장
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            서측광장을 가득 채우는 <br className="md:hidden" />
                            52개의 2차 창작 마켓 로드와 <br />
                            다양한 무대 프로그램이 함께합니다!
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont2Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont2Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "성남청년 플리마켓",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>일시</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        9/19(금)~9/20(토), 13:00 ~ 20:00
                    </p>
                </li>
                <li className="flex items-center gap-[8px] md:gap-[20px]">
                    <p className={txtBoxClass}>장소</p>
                    <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                        판교역 중앙광장
                    </p>
                </li>
                <li className="flex flex-col gap-[16px] md:gap-[40px]">
                    <div className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            GXG 2025에서 만나는 <br className="md:hidden" />
                            성남 로컬 브랜드 마켓! <br />
                            성남청년 플리마켓에서 축제의 <br className="md:hidden" />
                            또다른 재미를 느껴보세요!
                        </p>
                    </div>
                    <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont3Img1} alt="이미지" className="w-full" />
                        </li>
                        <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                            <img src={programFestaCont3Img2} alt="이미지" className="w-full" />
                        </li>
                    </ul>
                </li>
            </ul>
        ),
    },
    {
        title: "GV2025",
        background: "bg-program202505",
        img: icProgramFesta,
        contents: (
            <>
                <ul className="flex flex-col gap-[16px] md:gap-[24px]">
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>일시</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            9/19(금), 13:00 ~ 17:00
                        </p>
                    </li>
                    <li className="flex items-center gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>장소</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            경기창조경제혁신센터 B2 국제회의장
                        </p>
                    </li>
                    <li className="flex items-start gap-[8px] md:gap-[20px]">
                        <p className={txtBoxClass}>내용</p>
                        <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                            게임을 좋아하는 마음, <br className="md:hidden" />
                            이제는 진로로 확장할 때! <br />
                            성남시 청소년과 청년을 위한 <br className="md:hidden" />
                            게임진로 탐색 프로그램
                        </p>
                    </li>
                    <li className="flex flex-col gap-[16px] md:gap-[40px]">
                        <div className="flex items-start gap-[8px] md:gap-[20px]">
                            <p className={txtBoxClass}>강연자</p>
                            <p className="text-[16px] text-black flex-1 font-['GongGothicLight'] md:text-[18px]">
                                - 원더포션 허유지 산나비 메인 아티스트 <br className="md:hidden" />
                                &lt;대학 다니며 인디게임 출시하기&gt;
                                <br />
                                - 마이크로소프트 한국 게임사업부 김지선 선임 영업대표 <br className="xl:hidden" />
                                &lt;비전공자의 커리어 퀘스트: 게임회사에서 마이크로소프트까지, 그리고 AI 이야기 &gt;
                                <br />
                                - 슈퍼셀 이욱진 클래시로얄 서버 개발자 <br className="md:hidden" />
                                &lt;실시간 대전 서버를 위한 넓고 얇은 지식 &gt;
                                <br />- 엔씨소프트 장현영 상무 <br className="md:hidden" />
                                &lt;직업인으로서의 게임, 그리고 게임인 &gt;
                            </p>
                        </div>
                        <ul className="flex flex-wrap gap-[8px] md:gap-[20px]">
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programFestaCont4Img1} alt="이미지" className="w-full" />
                            </li>
                            <li className="w-[calc(50%-4px)] md:w-[calc(50%-10px)] xl:w-[calc(33.333%-13.333px)]">
                                <img src={programFestaCont4Img2} alt="이미지" className="w-full" />
                            </li>
                        </ul>
                    </li>
                </ul>
                <a
                    href="https://forms.gle/vYJiSuxRnbzeG1aS8"
                    target="_blank"
                    rel="noreferrer"
                    className="m-[20px_auto_0] relative block w-full h-[72px] text-white text-[20px] text-center leading-[70px] font-['GongGothicMedium'] clip-path-octagon border border-black bg-black max-w-[320px]"
                >
                    <span>GV2025 참가 신청하기</span>
                    <span className="absolute left-0 top-0 border-[8px] border-black border-b-transparent border-r-transparent" />
                    <span className="absolute left-0 bottom-0 border-[8px] border-black border-t-transparent border-r-transparent" />
                    <span className="absolute right-0 top-0 border-[8px] border-black border-b-transparent border-l-transparent" />
                    <span className="absolute right-0 bottom-0 border-[8px] border-black border-t-transparent border-l-transparent" />
                </a>
            </>
        ),
    },
];

export default function Festa() {
    return (
        <>
            <div className="p-[48px_0_20px] xl:pt-[60px] text-[12px] font-['GongGothicLight'] md:text-[18px] xl:text-[24px] xl:text-right">
                * 프로그램 구성 및 시간은 현장 상황에 따라 변동될 수 있습니다.
            </div>
            <ProgramAccordion
                list={programList}
                triggerClassName="justify-start gap-[8px] pl-[12px] md:pl-[20px] md:gap-[28px] [&>p]:text-[18px] [&>p]:md:text-[32px]"
                contentClassName="p-[20px_0] md:p-[40px_0] xl:p-[40px]"
            />
        </>
    );
}
